module.exports = {
    path: '/asset-management',
    meta: { module: 'am' },
    component: () => import('@am/App'),
    children: [
        {
            path: 'assets',
            alias: '',
            name: 'am-assets',
            component: () => import('@am/views/Assets')
        },
        {
            path: 'assets/new',
            alias: 'new-asset',
            name: 'am-asset-new',
            component: () => import('@am/views/Assets')
        },
        {
            path: 'assets/:assetId/edit',
            alias: 'edit-asset/:assetId',
            name: 'am-asset-edit',
            component: () => import('@am/views/Assets')
        },
        {
            path: 'assets/:assetId',
            name: 'am-asset',
            component: () => import('@am/views/Assets')
        },
        {
            path: 'sites',
            name: 'am-sites',
            component: () => import('@am/views/Sites')
        },
        {
            path: 'sites/new',
            alias: '/new-site',
            name: 'am-site-new',
            component: () => import('@am/views/Sites')
        },
        {
            path: 'sites/:siteId/edit',
            alias: 'edit-site/:siteId',
            name: 'am-site-edit',
            component: () => import('@am/views/Sites')
        },
        {
            path: 'sites/:siteId',
            name: 'am-site',
            component: () => import('@am/views/Sites')
        },
    ]
};



// WEBPACK FOOTER //
// ./src/modules/asset/router.js